/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DataContext {
    getFixupPrototypeFunction() { return DataContext.fixupPrototype; }

    static newInstance(model: Partial<DataContext>): DataContext {
        let obj = Object.assign(new DataContext(), model);
        DataContext.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DataContext>): DataContext {
        if (!model) return null;
        return DataContext.newInstance(<DataContext> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DataContext) {
        if (!obj) return;

        models.DataContext.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DataContext): boolean {
        Object.setPrototypeOf(obj, DataContext.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.filter) {
            models.AccountFilters.fixupPrototype(this.filter);
        }
        if (this.timeRange) {
            models.RangeSelection.fixupPrototype(this.timeRange);
        }
        if (this.query) {
            models.QueryOperator.fixupPrototype(this.query);
        }
    }

    filter: models.AccountFilters;

    /**
     * currency of the cost. Example 'currency':'USD'
     */
    currency: models.Currency;

    /**
     * Use organization currency rules to convert to the configured currency
     */
    organizationCurrency: boolean;

    timeRange: models.RangeSelection;

    /**
     * Advanced query based filters. If present, will be used instead of hierarchical filters.
     */
    query: models.QueryOperator;

    /**
     * Billing source for the data
     */
    billingSource: string;

    /**
     * Granularity to aggregate data
     */
    granularity: models.TrendGranularity;

    overrideQuery: boolean;

    overrideBillingSource: boolean;

    overrideGranularity: boolean;

    overrideTenants: boolean;

    overrideCloudProviders: boolean;

    overrideCloudAccounts: boolean;

    overrideCurrency: boolean;

    overrideTimeRange: boolean;

    overrideRegions: boolean;

    overrideProductCategories: boolean;

    hideBillingSource: boolean;

    hideGranularity: boolean;

    hideTenants: boolean;

    hideCloudProviders: boolean;

    hideCloudAccounts: boolean;

    hideCurrency: boolean;

    hideTimeRange: boolean;

    hideRegions: boolean;

    hideProductCategories: boolean;

}
